export default "__VITE_ASSET__6b07c039__"